/* FB | Sepet ilk-ekleme gorsel HAZIR-OLANA-KADAR-TUT + Hediye modal gorsel on-isitma (v3) — additive.
   KOK NEDEN (v2): ilk eklemede sepet satir gorseli buyuk + onbellekte olmadan yuklenir, spinner gorsel
   yuklenmeden kapanir -> drawer dolu gorunup gorsel ~0.3s sonra "pop-in" yapar.
   (A) ATC aninda eklenen urun gorselini cok boyutta on-isit; (B) sepet satir gorseli yuklenene kadar
   fb-atc-pending spinner'ini TUT.
   v3 EK (C): "Hediye paketi ekle" modali sepet urunlerinin gorselini (cart.js it.image, tam boy) gosterir;
   bu gorseller modal acilinca gec geliyordu. Artik sepet yuklendikten SONRA ve her cart:update'te bu
   gorseller DUSUK ONCELIKLE arka planda on-isitilir -> tiklayinca aninda hazir. */
(function () {
  'use strict';
  if (window.__fbCartImgReady) return;
  window.__fbCartImgReady = 3;

  function D() { return document.querySelector('cart-drawer-component'); }
  function lineImgs(d) {
    var dlg = d && d.querySelector('dialog');
    return dlg ? [].slice.call(dlg.querySelectorAll('.cart-items__media-image')) : [];
  }
  function notReady(d) {
    return lineImgs(d).filter(function (im) { return !(im.complete && im.naturalWidth > 0); });
  }
  function warm(u, hi) {
    if (!u) return;
    try { var i = new Image(); i.decoding = 'async'; try { i.fetchPriority = hi ? 'high' : 'low'; } catch (e) {} i.src = u; } catch (e) {}
  }
  function withW(u, w) {
    try { return /([?&])width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; } catch (e) { return u; }
  }
  function stripW(u) {
    try { return u.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, ''); } catch (e) { return u; }
  }

  /* (A) ATC aninda eklenen urunun gorselini cok boyutta on-isit */
  function warmVariant() {
    try {
      var med = document.querySelector('add-to-cart-component[data-product-variant-media]');
      var mu = med && med.getAttribute('data-product-variant-media');
      if (!mu) {
        var im = document.querySelector('.product-media-container img, product-media-gallery img, .product__media img');
        mu = im && (im.currentSrc || im.getAttribute('src'));
      }
      if (!mu) return;
      warm(withW(mu, 250), true);
      warm(stripW(mu), true);
      warm(withW(mu, 540), false);
    } catch (e) {}
  }

  var atcUntil = 0;
  function markAtc() { atcUntil = Date.now() + 6000; warmVariant(); reconcile(); }
  function maybeAtc(e) {
    try { var t = e.target; if (t && t.closest && t.closest('#fbAddToCart')) markAtc(); } catch (err) {}
  }
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, maybeAtc, true);
  });
  document.addEventListener('submit', function (e) {
    try { if (e.target && e.target.matches && e.target.matches('form[data-type="add-to-cart-form"]')) markAtc(); } catch (err) {}
  }, true);

  /* (B) sepet satir gorseli yuklenene kadar spinner'i tut (erken kapanmayi engelle) */
  var weHeld = false;
  function reconcile() {
    var d = D();
    if (!d) return;
    var active = Date.now() <= atcUntil;
    if (!active) { if (weHeld) { d.classList.remove('fb-atc-pending'); weHeld = false; } return; }
    var nr = notReady(d);
    if (nr.length) {
      if (!d.classList.contains('fb-atc-pending')) d.classList.add('fb-atc-pending');
      weHeld = true;
      nr.forEach(function (im) {
        if (im.__fbCIR) return; im.__fbCIR = 1;
        im.addEventListener('load', reconcile, { once: true });
        im.addEventListener('error', reconcile, { once: true });
      });
    } else {
      if (weHeld) { d.classList.remove('fb-atc-pending'); weHeld = false; }
    }
  }
  function watch() {
    var d = D(); if (!d) return;
    try { new MutationObserver(reconcile).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src', 'srcset'] }); } catch (e) {}
  }

  /* (C) Hediye paketi modalindaki sepet-urun gorsellerini DUSUK ONCELIKLE arka planda on-isit.
     Modal (.fb-gw-pimg) src = /cart.js it.image (tam boy). cart:update + load sonrasi idle'da isitilir. */
  var giftSeen = {};
  function warmGiftModalImages() {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !c.items) return;
          c.items.forEach(function (it) {
            if (it && (it.handle === 'hediye-paketi' || it.variant_id === 46513653416097)) return; /* hediye urununun kendisi haric */
            var u = it && (it.image || (it.featured_image && it.featured_image.url));
            if (u && !giftSeen[u]) { giftSeen[u] = 1; warm(u, false); }
          });
        }).catch(function () {});
    } catch (e) {}
  }
  function idleGift() {
    try { if ('requestIdleCallback' in window) requestIdleCallback(warmGiftModalImages, { timeout: 3000 }); else setTimeout(warmGiftModalImages, 700); }
    catch (e) { setTimeout(warmGiftModalImages, 700); }
  }

  document.addEventListener('cart:update', function () {
    setTimeout(reconcile, 0); setTimeout(reconcile, 120);
    idleGift();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  setTimeout(watch, 1500);
  if (document.readyState === 'complete') idleGift(); else window.addEventListener('load', idleGift, { once: true });
})();

/* FB INP (2026-08-02): sepet-drawer acik durumunu body.fb-cart-open sinifina yansit.
   header.liquid'de body:has(.cart-drawer__dialog[open]) -> body.fb-cart-open donusumu icin
   (her sepet ac/kapatta tum header'i recalc eden :has yuku kaldirildi). Tek elemanin tek
   attribute'unu (open) izler = maliyet ihmal edilebilir. Geri almak: bu blogu sil. */
(function(){
  if(window.__fbCartOpenClass) return; window.__fbCartOpenClass=1;
  function sel(){ return document.querySelector('cart-drawer-component dialog.cart-drawer__dialog') || document.querySelector('.cart-drawer__dialog'); }
  function sync(d){ if(d) document.body.classList.toggle('fb-cart-open', d.hasAttribute('open')); }
  function attach(){ var d=sel(); if(!d) return false; try{ new MutationObserver(function(){ sync(d); }).observe(d,{attributes:true,attributeFilter:['open']}); }catch(e){} sync(d); return true; }
  function boot(){ if(!attach()){ var n=0,t=setInterval(function(){ if(attach()||++n>25) clearInterval(t); },300); } }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();